export default "__VITE_ASSET__DKkVURGC__"